import React from 'react';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

import { Button } from '@tcc/crate';

const baseString = 'vra-does-not-meet-requirements';
const classString = classNames({
  [`${baseString}`]: true
});
const DoesNotMeetRequirements = ({
  isAppMode,
  onClickImportLink,
  onClickManualScriptTrigger
}) => {

  const importStep = isAppMode ? getMessage(`help-text__more-data__next-steps--1--app`) : (
    <span>
      <Button
        data-test-id="upload-yield-data"
        mode='link'
        onClick={onClickImportLink}>
        {getMessage(`help-text__more-data__next-steps--1--link`)}
      </Button> {getMessage(`help-text__more-data__next-steps--1--description`)}
    </span>
  );

  return (
    <section className={classString} data-test-id={`${baseString}`}>
      <p className={`${baseString}__intro`} data-test-id='more-data-text'>
        {getMessage(`help-text__more-data__intro`)}
      </p>
      <p className={`${baseString}__next-steps--intro`}>
        {getMessage(`help-text__more-data__next-steps--intro`)}
      </p>
      <ul className={`help-text__more-data__next-steps`} data-test-id={`${baseString}__next-steps`}>
        <li>
          {importStep}
        </li>
        <li>
          <Button
            data-test-id="create-manual-script"
            mode='link'
            onClick={ () => { onClickManualScriptTrigger(); } }>
            {getMessage(`help-text__more-data__next-steps--2--link`)}
          </Button>
          &nbsp;{getMessage(`help-text__more-data__next-steps--2--description`)}
        </li>
      </ul>
    </section>
  );
};
DoesNotMeetRequirements.propTypes = {
  isAppMode: propTypes.bool.isRequired,
  onClickImportLink: propTypes.func.isRequired,
  onClickManualScriptTrigger: propTypes.func.isRequired,
  upgradePath: propTypes.string.isRequired
};
export default DoesNotMeetRequirements;
